module.exports = __webpack_public_path__ + "static/futureproof-546466bb34bf472bf0526af006269d0a.svg";